export default function LoginErrorComponent() {
  return (
    <div>
      <p>Authentication Failed: You must be a member of the JJC Racing Discord server.</p>
    </div>
  )
}